module.exports = __webpack_public_path__ + "images/connectbikea6dced20934b785334711968014a3d62.png";